import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Theme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DropdownInput from "common/components/DropdownInput";
import { useTranslation } from "common/locales";
import { GENERAL_FEED_UNITS } from "model";

const PREFIX = "FeedUnitDropdown";

const classes = {
  formControl: `${PREFIX}-formControl`,
};

const StyledFormControl = styled(FormControl)(
  ({ theme }: { theme: Theme }) => ({
    [`&.${classes.formControl}`]: {
      maxWidth: 400,
      paddingBottom: theme.spacing(2),
    },
  })
);

interface FeedUnitDropdownProps {
  currentUnit?: GENERAL_FEED_UNITS;
  disabled: boolean;
  onChange: (e: SelectChangeEvent<GENERAL_FEED_UNITS>) => void;
  feedUnitInputError: boolean;
  label: string;
  name: string;
}

export default function FeedUnitDropdown({
  disabled,
  onChange,
  currentUnit,
  feedUnitInputError,
  label,
  name,
}: FeedUnitDropdownProps) {
  const { t } = useTranslation();

  return (
    <StyledFormControl
      className={classes.formControl}
      disabled={disabled}
      error={feedUnitInputError}
      fullWidth
    >
      <InputLabel
        id="feed-unit-type-select-label"
        variant="standard"
        shrink={true}
        error={feedUnitInputError}
        required
      >
        {t(label)}
      </InputLabel>
      <Select
        labelId="feed-unit-type-select-label"
        id="feed-unit-type-select"
        value={currentUnit ?? ("" as GENERAL_FEED_UNITS)}
        onChange={onChange}
        input={<DropdownInput />}
        error={feedUnitInputError}
        name={name}
      >
        {Object.entries(GENERAL_FEED_UNITS).map(([key, value]) => (
          <MenuItem value={value} key={key}>
            {t(`feedPurchase.feedUnit.option.${value}`)}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
}
